import _extends from'@babel/runtime/helpers/extends';import _objectSpread from'@babel/runtime/helpers/objectSpread2';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import PropTypes from'prop-types';import {FormattedMessage}from'react-intl';import useRichTextValues from'../../hooks/useRichTextValues.js';var FormattedRichMessage = function FormattedRichMessage(_ref) {
  var id = _ref.id,
    values = _ref.values,
    errorValues = _ref.errorValues,
    otherProps = _objectWithoutProperties(_ref, ["id", "values", "errorValues"]);
  var richTextValues = useRichTextValues();
  return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, otherProps, {
    id: id,
    values: _objectSpread(_objectSpread(_objectSpread({}, richTextValues), values), errorValues)
  }));
};
process.env.NODE_ENV !== "production" ? FormattedRichMessage.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.shape({
    id: PropTypes.string
  }),
  errorValues: PropTypes.shape({
    id: PropTypes.string
  })
} : void 0;
FormattedRichMessage.defaultProps = _objectSpread(_objectSpread({}, FormattedMessage.defaultProps), {}, {
  values: {},
  errorValues: {}
});
var FormattedRichMessage$1 = FormattedRichMessage;export{FormattedRichMessage$1 as default};